import List from "@/components/treeList";
import Bus from "./Bus.js";
import { Message } from "element-ui";
import { upAndDown } from "@/api/rescategory";

const Table = args => {
  //置顶、上移、下移
  function uad(row, status, flag) {
    if (flag) {
      upAndDown(row.pid, row.id, status).then(res => {
        if (res && res.code == 0) {
          Bus.$emit("initTable");
        }
        Message({
          message: "操作成功",
          type: "success"
        });
      });
    }
  }

  const Move = ({ props: { vo } }) => {
    const item = vo.row;
    const canMoveUp = item.headAndHail != 1 && item.headAndHail != 0;
    const canMoveDown = item.headAndHail != 2 && item.headAndHail != 0;
    const dealConf = [
      [
        "置顶",
        () => uad(item, 2, canMoveUp),
        !canMoveUp ? "disabled" : "deal-btn",
        "category:ud"
      ],
      [
        "上移",
        () => uad(item, 0, canMoveUp),
        !canMoveUp ? "disabled" : "deal-btn",
        "category:ud"
      ],
      [
        "下移",
        () => uad(item, 1, canMoveDown),
        !canMoveDown ? "disabled" : "deal-btn",
        "category:ud"
      ]
    ];
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <span class={item[2]} onClick={item[1]} v-permission={item[3]}>
            {item[0]}
          </span>
        ))}
      </div>
    );
  };

  // 新增子类
  function handleChild({ id }) {
    Bus.$emit("addRes", id, "新增子类");
  }

  // 编辑
  function handleUpdate({ id }) {
    Bus.$emit("updateRes", id);
  }

  //删除
  function handleDelete(item) {
    Bus.$emit("deleteRes", item);
  }

  //显示、隐藏
  function hideShow(row, status) {
    Bus.$emit("hideShowRes", row.id, status);
  }

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    const show = item.type == "1";
    const dealConf = [
      ["新增子类", () => handleChild(item), "icon-add", "category:save"],
      ["编辑", () => handleUpdate(item), "icon-edit", "category:update"],
      ["删除", () => handleDelete(item), "icon-delete", "category:delete"],
      [
        show ? "隐藏" : "显示",
        show ? () => hideShow(item, 0) : () => hideShow(item, 1),
        show ? "icon-hide" : "icon-show",
        "category:show"
      ]
    ];
    if (item.pid != 0) {
      dealConf.splice(0, 1);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[0]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[2]} onClick={item[1]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "资源分类",
      prop: "name"
    },
    {
      label: "排序",
      prop: "order",
      render: vo => <Move vo={vo} />
    },
    {
      label: "操作",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  return (
    <div>
      <List {...args} talbeCols={AccountTableConfig} />
    </div>
  );
};

export default Table;
